export const lightReviewFragment = /* GraphQL */ `
  fragment lightReviewData on Review {
    id
    type
    elementID
    status
    updatedAt
    metadata {
      key
      value
      type
    }
    messages(limit: 1) {
      items {
        id
      }
    }
  }
`

export const reviewFragment = /* GraphQL */ `
  fragment fullReviewData on Review {
    id
    byUserID
    organizationID
    organizationMasterID
    toUserID
    productID
    elementID
    byUser {
      id
      name
    }
    type
    status
    createdAt
    updatedAt
    metadata {
      key
      value
      type
    }
  }
`
